import React from 'react';

import './offers-header-module-layout.scss';

export const OffersHeaderModuleLayout: React.FC = ({ children }): React.ReactElement => {
    return <div className="offers-header-module-layout">{children}</div>;
};
